"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var React = __importStar(require("react"));
var icons_1 = require("../icons");
var theme_1 = require("../theme");
var utils_1 = require("../utils");
var styles_1 = require("./styles");
var colors = theme_1.theme.colors;
var Checkbox = function (_a) {
    var checked = _a.checked, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.error, error = _c === void 0 ? false : _c, props = __rest(_a, ["checked", "disabled", "error"]);
    return (React.createElement(styles_1.CheckboxStyledView, __assign({ borderWidth: "regular", borderColor: "n70", borderRadius: "rounded", backgroundColor: "n30", borderStyle: "solid", height: "20px", width: "20px", left: "0", top: "0", role: "checkbox", "aria-checked": checked, checked: checked, disabled: disabled, error: error, tabIndex: disabled ? -1 : 0, onClick: props.onChange, onKeyDown: function (event) {
            if ((0, utils_1.isKeyPressed)({
                event: event,
                key: 'SPACE',
            }) &&
                props.onChange &&
                !disabled) {
                props.onChange(event);
            }
        } }, props), checked && React.createElement(icons_1.CheckIcon, { size: 'auto', color: colors.white })));
};
exports.Checkbox = Checkbox;
//# sourceMappingURL=index.js.map